import { createTheme, defaultDarkModeOverride } from '@aws-amplify/ui-react';

import { brand, fontFamily } from './tokens';

/**
 * Maps the Koch brand tokens onto Amplify UI's theme so the Authenticator
 * (sign-in, forgot password, etc.) doesn't look like a different app.
 */
export const amplifyTheme: ReturnType<typeof createTheme> = createTheme({
  name: 'ops-utility-hub',
  overrides: [defaultDarkModeOverride],
  tokens: {
    colors: {
      brand: {
        primary: {
          10: { value: brand.blueLight },
          80: { value: brand.blue },
          90: { value: brand.blue },
          100: { value: brand.blueDark },
        },
      },
    },
    fonts: {
      default: {
        static: { value: fontFamily },
        variable: { value: fontFamily },
      },
    },
  },
});
